module.exports = __webpack_public_path__ + "img/linkedin4.f7db0016.svg";